import { proxy } from "valtio/vanilla";
import {
  getDefaultHmlrFilters,
  defaultHometrackFilters,
  getDefaultFilters,
} from "react-migration/domains/comparables/util/defaultFilters";
import { ComparablesState } from "react-migration/domains/comparables/typings/Comparables";
import { PerUnitPriceModes } from "react-migration/domains/comparables/typings/PriceModes";
import { PriceTypes } from "react-migration/domains/comparables/typings/PriceTypes";

export type ComparablesStore = {
  filters: ComparablesState["filters"];
  // Independent filter states for each data source
  hmlrFilters: ComparablesState["hmlrFilters"];
  hometrackFilters: ComparablesState["hometrackFilters"];
  filtersOpen: ComparablesState["filtersOpen"];
  dataSource: ComparablesState["dataSource"];
  priceMode: ComparablesState["priceMode"];
  // TODO: This should probably be in filters.. Works better that way
  priceSource: ComparablesState["priceSource"];
  priceType: ComparablesState["priceType"];
  smallUnitSize: ComparablesState["smallUnitSize"];
  incNoFloorArea: ComparablesState["incNoFloorArea"];
  RHPdisplayBy: ComparablesState["RHPdisplayBy"];
};

const localStorageKey = "comparablesState";

const storedStateString = localStorage.getItem(localStorageKey);

const defaultState = {
  // Independent filter states with the same default filters
  filters: getDefaultFilters(),
  hmlrFilters: getDefaultHmlrFilters(),
  hometrackFilters: defaultHometrackFilters,
  filtersOpen: true,
  dataSource: "hmlr",
  priceMode: PerUnitPriceModes.PRICE,
  priceSource: "All",
  priceType: PriceTypes.PER_UNIT,
  smallUnitSize: false,
  incNoFloorArea: false,
  RHPdisplayBy: PerUnitPriceModes.PRICE,
};

const previousComparablesStore = storedStateString ? JSON.parse(storedStateString) : {};

// TODO: What happens if they remove zoopla license after setting a hometrack record?
// TODO: Split out price mode
export const createComparablesStore = () => Object.assign(defaultState, previousComparablesStore);

const comparablesStore = proxy<ComparablesStore>(createComparablesStore());

export { comparablesStore, localStorageKey };
